import React from "react"

export const UserIcon = ({ size = 1, color = "#034055" }) => {
  return (
    <svg
      width={size * 24}
      height={size * 24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <g
          transform="translate(1)"
          fillRule="nonzero"
          stroke={color}
          strokeWidth="3"
        >
          <circle cx="11" cy="6" r="4.5" />
          <path d="M11 15.5c1.912 0 4.921.666 7.126 1.988 1.267.76 2.374 1.74 2.374 3.112v1.8h-19v-1.8c0-1.371 1.107-2.351 2.374-3.112C6.079 16.166 9.088 15.5 11 15.5z" />
        </g>
        <path fill="none" d="M0 0h24v24H0z" />
      </g>
    </svg>
  )
}
